import { useEffect, useState, useCallback } from "react";
import { useAuthContextV2 } from "../../../../../../auth-state";
import {
  gqlClient,
  gqlHeader,
  runGqlQueryV2,
} from "../../../../../../graphql/client";
import { GetQualifiedInvoiceBusinessIssuerByGroupIdQuery } from "../../../../../../graphql/generated/types";
import { reportUnexpectedError } from "@graffer-inc/smart-apply";
import { toast } from "react-toastify";

type Props = {
  applicationId: string;
  procedureId: string;
  groupId: string;
};

export const useQualifiedInvoiceNewPreviewContainer = ({ groupId }: Props) => {
  const { auth } = useAuthContextV2();

  const [businessIssuer, setBusinessIssuer] =
    useState<
      GetQualifiedInvoiceBusinessIssuerByGroupIdQuery["invoiceBusinessIssuerByGroupID"]
    >(null);

  const handleOnFetch = useCallback(async () => {
    try {
      const businessIssuerRes = await runGqlQueryV2(() =>
        gqlClient.getQualifiedInvoiceBusinessIssuerByGroupID(
          {
            orgId: auth.data?.orgId!,
            groupId: groupId,
          },
          gqlHeader("q"),
        ),
      );

      if (businessIssuerRes.error) {
        throw businessIssuerRes.error;
      }
      if (!businessIssuerRes.data?.invoiceBusinessIssuerByGroupID) {
        throw new Error(
          "cannot preview issue qualified invoice, no qualified invoice business issuer related",
        );
      }
      setBusinessIssuer(businessIssuerRes.data.invoiceBusinessIssuerByGroupID);
    } catch (e) {
      reportUnexpectedError(e);
      toast.error(
        "プレビュー表示時にエラーが発生しました。時間をおいて再度お試しください。",
      );
    }
  }, [auth.data?.orgId, groupId]);

  useEffect(() => {
    handleOnFetch();
  }, [handleOnFetch]);

  return {
    businessIssuer,
  };
};
